// (function () {
//   function getVariants(card) {
//     try {
//       return JSON.parse(card.dataset.variants || '[]');
//     } catch (err) {
//       console.error('Invalid variants JSON:', card.dataset.variants);
//       return [];
//     }
//   }

//   // check all three option slots so Color doesn't have to be option1
//   function findVariantByColor(variants, color) {
//     return variants.find(function (v) {
//       return v.option1 === color || v.option2 === color || v.option3 === color;
//     });
//   }

//   document.addEventListener('mouseover', function (e) {
//     const swatch = e.target.closest('.swatch');
//     if (!swatch) return;

//     const color = swatch.dataset.value;
//     if (!color) return;

//     const card = swatch.closest('.product-card-wrapper');
//     if (!card) return;

//     const variant = findVariantByColor(getVariants(card), color);
//     if (!variant) return;

//     swatch.parentElement.querySelectorAll('.swatch').forEach(function (s) {
//       s.classList.remove('selected');
//     });
//     swatch.classList.add('selected');

//     if (variant.featured_image && variant.featured_image.src) {
//       card.querySelectorAll('.card__media .media img').forEach(function (img) {
//         img.src = variant.featured_image.src;
//         img.srcset = variant.featured_image.src;
//       });
//     }
//   });

//   // optional: click a swatch to go to that variant's PDP
//   document.addEventListener('click', function (e) {
//     const swatch = e.target.closest('.swatch');
//     if (!swatch) return;

//     const color = swatch.dataset.value;
//     if (!color) return;

//     const card = swatch.closest('.product-card-wrapper');
//     if (!card) return;

//     const variant = findVariantByColor(getVariants(card), color);
//     if (!variant) return;

//     const link = card.querySelector('a.full-unstyled-link');
//     if (!link) return;

//     const sep = link.href.includes('?') ? '&' : '?';
//     window.location.href = link.href + sep + 'variant=' + variant.id;
//   });
// })();


(function () {
  const CARD_SELECTOR = '.product-card-wrapper';
  const CARD_SWATCH_SELECTOR =
    '.product-card-wrapper .color-swatches .swatch';

  const supportsHover = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  function getVariants(card) {
    try {
      return JSON.parse(card.dataset.variants || '[]');
    } catch (error) {
      console.error('Invalid variants JSON:', error);
      return [];
    }
  }

  function findVariantByColor(variants, color) {
    return variants.find(function (variant) {
      return (
        variant.option1 === color ||
        variant.option2 === color ||
        variant.option3 === color
      );
    });
  }

  // function formatMoney(cents) {
  //   const amount = Number(cents || 0);

  //   if (
  //     window.Shopify &&
  //     typeof window.Shopify.formatMoney === 'function'
  //   ) {
  //     const moneyFormat =
  //       window.theme?.moneyFormat ||
  //       window.theme?.money_format ||
  //       window.moneyFormat ||
  //       '${{amount}}';

  //     return window.Shopify.formatMoney(
  //       amount,
  //       moneyFormat
  //     );
  //   }

  //   const currency =
  //     window.Shopify?.currency?.active || 'USD';

  //   try {
  //     return new Intl.NumberFormat(
  //       document.documentElement.lang || 'en-US',
  //       {
  //         style: 'currency',
  //         currency: currency,
  //       }
  //     ).format(amount / 100);
  //   } catch (error) {
  //     return (amount / 100).toFixed(2);
  //   }
  // }


  // function formatMoney(cents) {
  //   const amount = Number(cents || 0);

  //   const moneyFormat =
  //     window.cardMoneyFormat ||
  //     window.theme?.moneyFormat ||
  //     window.theme?.money_format ||
  //     window.moneyFormat ||
  //     '{{amount}}';

  //   if (
  //     window.Shopify &&
  //     typeof window.Shopify.formatMoney === 'function'
  //   ) {
  //     return window.Shopify.formatMoney(
  //       amount,
  //       moneyFormat
  //     );
  //   }

  //   const value = (amount / 100).toFixed(2);

  //   return moneyFormat
  //     .replace(/\{\{\s*amount\s*\}\}/g, value)
  //     .replace(
  //       /\{\{\s*amount_no_decimals\s*\}\}/g,
  //       Math.round(amount / 100).toString()
  //     )
  //     .replace(
  //       /\{\{\s*amount_with_comma_separator\s*\}\}/g,
  //       value.replace('.', ',')
  //     )
  //     .replace(
  //       /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
  //       Math.round(amount / 100).toString()
  //     );
  // }

  function getProductLinks(card) {
    return card.querySelectorAll(
      '.card__media a,' +
        '.card__heading a.full-unstyled-link,' +
        '.btn-wrapper a'
    );
  }

  function getPriceWrapper(card) {
    return card.querySelector(
      '.card__information .card-information > .price'
    );
  }

  function getPrimaryImage(card) {
    return card.querySelector(
      '.card__media .media > a:first-child img'
    );
  }

  const preloadedImageUrls = new Set();

  // function preloadDefaultImage(src) {
  //   if (src && !preloadedImageUrls.has(src)) {
  //     preloadedImageUrls.add(src);
  //     const preloader = new Image();
  //     preloader.src = src;
  //   }
  // }


  function preloadDefaultImage(src, srcset) {
    if (src && !preloadedImageUrls.has(src)) {
      preloadedImageUrls.add(src);
      const preloader = new Image();
      preloader.src = src;
    }

    if (srcset) {
      srcset.split(',').forEach(function (candidate) {
        const url = candidate.trim().split(/\s+/)[0];
        if (url && !preloadedImageUrls.has(url)) {
          preloadedImageUrls.add(url);
          const srcsetPreloader = new Image();
          srcsetPreloader.src = url;
        }
      });
    }
  }

  function saveDefaultCardState(card) {
    if (card.dataset.defaultStateSaved === 'true') {
      return;
    }

    const selectedSwatch = card.querySelector(
      '.color-swatches .swatch.selected'
    );

    if (selectedSwatch) {
      card.dataset.defaultColor =
        selectedSwatch.dataset.value || '';
    }

    const priceWrapper = getPriceWrapper(card);

    if (priceWrapper) {
      priceWrapper.dataset.defaultPriceHtml =
        priceWrapper.innerHTML;

      priceWrapper.dataset.defaultPriceClass =
        priceWrapper.className;
    }

    const primaryImage = getPrimaryImage(card);

    if (primaryImage) {
      primaryImage.dataset.defaultSrc =
        primaryImage.getAttribute('src') || '';

      primaryImage.dataset.defaultSrcset =
        primaryImage.getAttribute('srcset') || '';

      primaryImage.dataset.defaultSizes =
        primaryImage.getAttribute('sizes') || '';

      primaryImage.dataset.defaultAlt =
        primaryImage.getAttribute('alt') || '';
      
      // preloadDefaultImage(primaryImage.dataset.defaultSrc);
      preloadDefaultImage(
        primaryImage.dataset.defaultSrc,
        primaryImage.dataset.defaultSrcset
      );
    }

    getProductLinks(card).forEach(function (link) {
      const href = link.getAttribute('href');

      if (href && !link.dataset.defaultHref) {
        link.dataset.defaultHref = href;
      }
    });

    card.dataset.defaultStateSaved = 'true';
  }

  function setSelectedSwatch(card, selectedSwatch) {
    card
      .querySelectorAll('.color-swatches .swatch')
      .forEach(function (swatch) {
        swatch.classList.remove(
          'selected',
          'active'
        );

        swatch.removeAttribute('aria-current');
        swatch.setAttribute(
          'aria-pressed',
          'false'
        );
      });

    selectedSwatch.classList.add('selected');

    selectedSwatch.setAttribute(
      'aria-current',
      'true'
    );

    selectedSwatch.setAttribute(
      'aria-pressed',
      'true'
    );
  }

  function getVariantImageUrl(variant) {
    if (!variant) return '';

    if (typeof variant.featured_image === 'string') {
      return variant.featured_image;
    }

    if (variant.featured_image?.src) {
      return variant.featured_image.src;
    }

    if (variant.featured_image?.url) {
      return variant.featured_image.url;
    }

    if (
      variant.featured_media?.preview_image?.src
    ) {
      return variant.featured_media.preview_image.src;
    }

    if (
      variant.featured_media?.preview_image?.url
    ) {
      return variant.featured_media.preview_image.url;
    }

    if (variant.featured_media?.src) {
      return variant.featured_media.src;
    }

    if (variant.image?.src) {
      return variant.image.src;
    }

    return '';
  }

  function normalizeImageUrl(imageUrl) {
    if (!imageUrl) return '';

    if (imageUrl.startsWith('//')) {
      return (
        window.location.protocol + imageUrl
      );
    }

    return imageUrl;
  }

  function updateCardImage(card, variant) {
    const imageUrl = normalizeImageUrl(
      getVariantImageUrl(variant)
    );
    

    if (!imageUrl) {
      console.warn(
        'No image found for selected variant:',
        variant
      );
      return;
    }

    const primaryImage = getPrimaryImage(card);

    if (!primaryImage) {
      console.warn(
        'Primary Dawn card image not found:',
        card
      );
      return;
    }

    primaryImage.setAttribute('src', imageUrl);

    /*
     * Remove the old responsive candidates while a
     * variant image is active. Otherwise Safari may
     * continue showing the old srcset candidate.
     */
    primaryImage.removeAttribute('srcset');
    primaryImage.removeAttribute('sizes');

    const imageAlt =
      variant.featured_image?.alt ||
      variant.featured_media?.alt;

    if (imageAlt) {
      primaryImage.setAttribute('alt', imageAlt);
    }

    card.classList.add(
      'card-variant-selected'
    );
  }

  // function updateCardPrice(card, variant) {
  //   const priceWrapper =
  //     getPriceWrapper(card);

  //   if (!priceWrapper) return;

  //   const price = Number(
  //     variant.price || 0
  //   );

  //   const compareAtPrice = Number(
  //     variant.compare_at_price || 0
  //   );

  //   const isOnSale =
  //     compareAtPrice > 0 &&
  //     compareAtPrice > price;

  //   priceWrapper
  //     .querySelectorAll(
  //       '.price__regular .price-item--regular'
  //     )
  //     .forEach(function (element) {
  //       element.textContent =
  //         formatMoney(price);
  //     });

  //   priceWrapper
  //     .querySelectorAll(
  //       '.price__sale .price-item--sale'
  //     )
  //     .forEach(function (element) {
  //       element.textContent =
  //         formatMoney(price);
  //     });

  //   priceWrapper
  //     .querySelectorAll(
  //       '.price__sale .price-item--regular'
  //     )
  //     .forEach(function (element) {
  //       element.textContent = isOnSale
  //         ? formatMoney(compareAtPrice)
  //         : '';
  //     });

  //   priceWrapper.classList.toggle(
  //     'price--on-sale',
  //     isOnSale
  //   );

  //   priceWrapper.classList.toggle(
  //     'price--sold-out',
  //     variant.available === false
  //   );
  // }

  function updateCardPrice(card, variant) {
    const priceWrapper = getPriceWrapper(card);
    if (!priceWrapper) return;

    const price = Number(variant.price || 0);
    const compareAtPrice = Number(
      variant.compare_at_price || 0
    );

    const isOnSale =
      compareAtPrice > 0 &&
      compareAtPrice > price;

    const formattedPrice =
      variant.price_formatted || '';

    const formattedComparePrice =
      variant.compare_at_price_formatted || '';

    priceWrapper
      .querySelectorAll(
        '.price__regular .price-item--regular'
      )
      .forEach(function (element) {
        element.textContent = formattedPrice;
      });

    priceWrapper
      .querySelectorAll(
        '.price__sale .price-item--sale'
      )
      .forEach(function (element) {
        element.textContent = formattedPrice;
      });

    priceWrapper
      .querySelectorAll(
        '.price__sale .price-item--regular'
      )
      .forEach(function (element) {
        element.textContent = isOnSale
          ? formattedComparePrice
          : '';
      });

    priceWrapper.classList.toggle(
      'price--on-sale',
      isOnSale
    );

    priceWrapper.classList.toggle(
      'price--sold-out',
      variant.available === false
    );
  }

  function createVariantUrl(
    baseUrl,
    variantId
  ) {
    if (!baseUrl || !variantId) {
      return baseUrl;
    }

    try {
      const url = new URL(
        baseUrl,
        window.location.origin
      );

      url.searchParams.set(
        'variant',
        variantId
      );

      return (
        url.pathname +
        url.search +
        url.hash
      );
    } catch (error) {
      console.error(
        'Unable to create variant URL:',
        error
      );

      return baseUrl;
    }
  }

  function updateCardLinks(
    card,
    variantId
  ) {
    if (!variantId) return;

    card.dataset.selectedVariantId =
      String(variantId);

    getProductLinks(card).forEach(
      function (link) {
        const baseUrl =
          link.dataset.defaultHref ||
          link.getAttribute('href');

        if (!baseUrl) return;

        link.setAttribute(
          'href',
          createVariantUrl(
            baseUrl,
            variantId
          )
        );
      }
    );
  }

  function updateCardFromSwatch(swatch) {
    const card = swatch.closest(
      CARD_SELECTOR
    );

    if (!card) return null;

    const color = swatch.dataset.value;
    if (!color) return null;

    saveDefaultCardState(card);

    const variant = findVariantByColor(
      getVariants(card),
      color
    );

    if (!variant) {
      console.warn(
        'No variant found for color:',
        color
      );

      return null;
    }

    setSelectedSwatch(card, swatch);
    updateCardImage(card, variant);
    updateCardPrice(card, variant);
    updateCardLinks(card, variant.id);

    return variant;
  }

  function restorePrimaryImage(card) {
    const primaryImage =
      getPrimaryImage(card);

    if (!primaryImage) return;

    if (primaryImage.dataset.defaultSrcset) {
      primaryImage.setAttribute(
        'srcset',
        primaryImage.dataset.defaultSrcset
      );
    } else {
      primaryImage.removeAttribute('srcset');
    }

    if (primaryImage.dataset.defaultSizes) {
      primaryImage.setAttribute(
        'sizes',
        primaryImage.dataset.defaultSizes
      );
    } else {
      primaryImage.removeAttribute('sizes');
    }

    if (primaryImage.dataset.defaultAlt) {
      primaryImage.setAttribute(
        'alt',
        primaryImage.dataset.defaultAlt
      );
    }

    const defaultSrc =
      primaryImage.dataset.defaultSrc;

    if (!defaultSrc) return;

    /*
     * Force Safari to re-evaluate the restored
     * responsive image after BFCache navigation.
     */
    primaryImage.removeAttribute('src');

    requestAnimationFrame(function () {
      primaryImage.setAttribute(
        'src',
        defaultSrc
      );
    });
  }

  function resetCardToDefault(card) {
    saveDefaultCardState(card);

    const defaultColor =
      card.dataset.defaultColor || '';

    card
      .querySelectorAll(
        '.color-swatches .swatch'
      )
      .forEach(function (swatch) {
        const isDefault =
          Boolean(defaultColor) &&
          swatch.dataset.value ===
            defaultColor;

        swatch.classList.toggle(
          'selected',
          isDefault
        );

        swatch.classList.remove('active');

        swatch.setAttribute(
          'aria-pressed',
          isDefault ? 'true' : 'false'
        );

        if (isDefault) {
          swatch.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          swatch.removeAttribute(
            'aria-current'
          );
        }
      });

    restorePrimaryImage(card);

    card.classList.remove(
      'card-variant-selected'
    );

    const priceWrapper =
      getPriceWrapper(card);

    if (
      priceWrapper &&
      priceWrapper.dataset
        .defaultPriceHtml !== undefined
    ) {
      priceWrapper.innerHTML =
        priceWrapper.dataset
          .defaultPriceHtml;

      if (
        priceWrapper.dataset
          .defaultPriceClass
      ) {
        priceWrapper.className =
          priceWrapper.dataset
            .defaultPriceClass;
      }
    }

    getProductLinks(card).forEach(
      function (link) {
        if (link.dataset.defaultHref) {
          link.setAttribute(
            'href',
            link.dataset.defaultHref
          );
        }
      }
    );

    delete card.dataset.selectedVariantId;
  }

  function initializeCards() {
    document
      .querySelectorAll(CARD_SELECTOR)
      .forEach(function (card) {
        saveDefaultCardState(card);
      });
  }

  function resetAllCards() {
    document
      .querySelectorAll(CARD_SELECTOR)
      .forEach(function (card) {
        resetCardToDefault(card);
      });
  }

  /*
   * Desktop hover only.
   * Mobile taps will not trigger this event.
   */
  document.addEventListener(
    'pointerover',
    function (event) {
      if (!supportsHover.matches) return;

      const swatch = event.target.closest(
        CARD_SWATCH_SELECTOR
      );

      if (!swatch) return;

      if (
        event.relatedTarget &&
        swatch.contains(
          event.relatedTarget
        )
      ) {
        return;
      }

      updateCardFromSwatch(swatch);
    }
  );

  /*
   * Collection-card swatch click/tap only.
   * PDP swatches are not affected.
   */
  document.addEventListener(
    'click',
    function (event) {
      const swatch = event.target.closest(
        CARD_SWATCH_SELECTOR
      );

      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      const card = swatch.closest(
        CARD_SELECTOR
      );

      if (!card) return;

      /*
       * Apply selected class, image, price and URL
       * before navigating.
       */
      const variant =
        updateCardFromSwatch(swatch);

      if (!variant) return;

      const baseUrl =
        card.dataset.productUrl ||
        card.querySelector(
          '.card__heading a.full-unstyled-link'
        )?.dataset.defaultHref ||
        card.querySelector(
          '.card__heading a.full-unstyled-link'
        )?.getAttribute('href');

      if (!baseUrl) return;

      const destination =
        createVariantUrl(
          baseUrl,
          variant.id
        );

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.location.assign(
            destination
          );
        });
      });

      // const imageUrl = getVariantImageUrl(variant);

      // const img = new Image();

      // img.onload = function () {
      //   window.location.assign(destination);
      // };

      // img.onerror = function () {
      //   window.location.assign(destination);
      // };

      // img.src = imageUrl;

      // // fallback
      // setTimeout(function () {
      //   window.location.assign(destination);
      // }, 800);




    }
  );

  /*
   * Title, image and custom Shop Now link.
   * Opens the most recently selected/hovered
   * card variant.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest(
          CARD_SWATCH_SELECTOR
        )
      ) {
        return;
      }

      const productLink =
        event.target.closest(
          `${CARD_SELECTOR} .card__media a,` +
            `${CARD_SELECTOR} .card__heading a.full-unstyled-link,` +
            `${CARD_SELECTOR} .btn-wrapper a`
        );

      if (!productLink) return;

      const card = productLink.closest(
        CARD_SELECTOR
      );

      if (!card) return;

      const variantId =
        card.dataset.selectedVariantId;

      /*
       * No card variant has been selected:
       * preserve normal Dawn navigation.
       */
      if (!variantId) return;

      event.preventDefault();

      const baseUrl =
        card.dataset.productUrl ||
        productLink.dataset.defaultHref ||
        productLink.getAttribute('href');

      if (!baseUrl) return;

      window.location.assign(
        createVariantUrl(
          baseUrl,
          variantId
        )
      );
    }
  );

  /*
   * Reset collection cards after Safari
   * Back/Forward Cache restoration.
   */
  window.addEventListener(
    'pageshow',
    function (event) {
      if (event.persisted) {
        resetAllCards();
      } else {
        initializeCards();
      }
    }
  );

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCards
    );
  } else {
    initializeCards();
  }
})();